<template>
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <!-- 主表单区域 -->
        <a-form :form="form" slot="detail">
          <a-row>
            <!-- <a-col :span="24" >
              <a-form-item label="用户ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-select-user-by-dep v-decorator="['userId']"/>
              </a-form-item>
            </a-col>
            <a-col :span="24" >
              <a-form-item label="试卷ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-search-select-tag v-decorator="['paperId']" dict="teaching_paper,paper_name,id" />
              </a-form-item>
            </a-col> -->
            <a-col :span="24" >
              <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag type="radio" v-decorator="['userPaperStatus']" :trigger-change="true" dictCode="user_paper_status" placeholder="请选择状态"/>
              </a-form-item>
            </a-col>
            <a-col :span="24" >
              <a-form-item label="用时" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['duration']" placeholder="请输入时间" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="24" >
              <a-form-item label="总得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['gotScore']" placeholder="请输入总得分" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="24" >
              <a-form-item label="排名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['ranking']" placeholder="请输入排名" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="24" >
              <a-form-item label="比赛ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-search-select-tag v-decorator="['contestId']" dict="teaching_contest,contest_name,id" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </j-form-container>
        <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="用户答卷" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :ref="refKeys[0]"
            :loading="teachingUserPaperItemTable.loading"
            :columns="teachingUserPaperItemTable.columns"
            :dataSource="teachingUserPaperItemTable.dataSource"
            :maxHeight="300"
            :disabled="formDisabled"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true"/>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </template>
  
  <script>
  
    import pick from 'lodash.pick'
    import { getAction } from '@/api/manage'
    import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
    import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
    import { validateDuplicateValue } from '@/utils/util'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
    import JDictSelectTag from "@/components/dict/JDictSelectTag"
    import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  
    export default {
      name: 'TeachingUserPaperForm',
      mixins: [JEditableTableMixin],
      components: {
        JFormContainer,
        JSelectUserByDep,
        JDictSelectTag,
        JSearchSelectTag,
      },
      data() {
        return {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
          },
          labelCol2: {
            xs: { span: 24 },
            sm: { span: 3 },
          },
          wrapperCol2: {
            xs: { span: 24 },
            sm: { span: 20 },
          },
          // 新增时子表默认添加几行空数据
          addDefaultRowNum: 1,
          validatorRules: {
          },
          refKeys: ['teachingUserPaperItem', ],
          tableKeys:['teachingUserPaperItem', ],
          activeKey: 'teachingUserPaperItem',
          // 用户答卷每个题
          teachingUserPaperItemTable: {
            loading: false,
            dataSource: [],
            columns: [
              {
                title: '提交时间',
                key: 'createTime',
                type: FormTypes.datetime,
                width:"200px",
                defaultValue: '',
              },
              // {
              //   title: '题目ID',
              //   key: 'questionId',
              //   type: FormTypes.select,
              //   dictCode:"",
              //   width:"200px",
              //   placeholder: '请输入${title}',
              //   defaultValue: '',
              //   validateRules: [{ required: true, message: '${title}不能为空' }],
              // },
              {
                title: '答案',
                key: 'answer',
                type: FormTypes.input,
                width:"200px",
                defaultValue: '',
              },
              {
                title: '答案作品文件',
                key: 'answerFile',
                type: FormTypes.input,
                token:true,
                responseName:"message",
                width:"200px",
                defaultValue: '',
              },
              {
                title: '得分',
                key: 'gotScore',
                type: FormTypes.inputNumber,
                width:"200px",
                defaultValue: '',
              },
              {
                title: '批改人',
                key: 'reviewId',
                type: FormTypes.input,
                width:"200px",
                defaultValue: '',
              },
              {
                title: '批改时间',
                key: 'reviewTime',
                type: FormTypes.datetime,
                width:"200px",
                defaultValue: '',
              },
              {
                title: '批改注释',
                key: 'reviewComment',
                type: FormTypes.input,
                width:"200px",
                defaultValue: '',
              },
            ]
          },
          url: {
            add: "/teaching/teachingUserPaper/add",
            edit: "/teaching/teachingUserPaper/edit",
            queryById: "/teaching/teachingUserPaper/queryById",
            teachingUserPaperItem: {
              list: '/teaching/teachingUserPaper/queryTeachingUserPaperItemByMainId'
            },
          }
        }
      },
      props: {
        //流程表单data
        formData: {
          type: Object,
          default: ()=>{},
          required: false
        },
        //表单模式：false流程表单 true普通表单
        formBpm: {
          type: Boolean,
          default: false,
          required: false
        },
        //表单禁用
        disabled: {
          type: Boolean,
          default: false,
          required: false
        }
      },
      computed: {
        formDisabled(){
          if(this.formBpm===true){
            if(this.formData.disabled===false){
              return false
            }
            return true
          }
          return this.disabled
        },
        showFlowSubmitButton(){
          if(this.formBpm===true){
            if(this.formData.disabled===false){
              return true
            }
          }
          return false
        }
      },
      created () {
        //如果是流程中表单，则需要加载流程表单data
        this.showFlowData();
      },
      methods: {
        addBefore(){
          this.form.resetFields()
          this.teachingUserPaperItemTable.dataSource=[]
        },
        getAllTable() {
          let values = this.tableKeys.map(key => getRefPromise(this, key))
          return Promise.all(values)
        },
        /** 调用完edit()方法之后会自动调用此方法 */
        editAfter() {
          let fieldval = pick(this.model,'userId','paperId','userPaperStatus','remainTime','gotScore','ranking','contestId')
          this.$nextTick(() => {
            this.form.setFieldsValue(fieldval)
          })
          // 加载子表数据
          if (this.model.id) {
            let params = { id: this.model.id }
            this.requestSubTableData(this.url.teachingUserPaperItem.list, params, this.teachingUserPaperItemTable)
          }
        },
        /** 整理成formData */
        classifyIntoFormData(allValues) {
          let main = Object.assign(this.model, allValues.formValue)
          return {
            ...main, // 展开
            teachingUserPaperItemList: allValues.tablesValue[0].values,
          }
        },
        //渲染流程表单数据
        showFlowData(){
          if(this.formBpm === true){
            let params = {id:this.formData.dataId};
            getAction(this.url.queryById,params).then((res)=>{
              if(res.success){
                this.edit (res.result);
              }
            })
          }
        },
        validateError(msg){
          this.$message.error(msg)
        },
       popupCallback(row){
         this.form.setFieldsValue(pick(row,'userId','paperId','userPaperStatus','duration','gotScore','ranking','contestId'))
       },
  
      }
    }
  </script>
  
  <style scoped>
  </style>